import {Box, Center, Flex, Heading, Stack, Tag, TagLabel, Text, useColorMode} from '@chakra-ui/react'
import Image from 'next/image'
import {FaCalendar as CalendarIcon, FaMapMarkerAlt as LocationIcon} from 'react-icons/fa'

import providerLogo from '../../public/GCM-logo.svg'
import {formatStartDateOnlyWithoutTimezone} from "../../utils/dateUtils";

const normalizeSrc = src => src.startsWith('/') ? src.slice(1) : src;

const cloudflareLoader = ({src, width, quality}) => {
    // const width = 600
    const params = [`width=${width}`];
    if (quality) {
        params.push(`quality=${quality}`);
    }
    // params.push(`height=500`)
    const paramsString = params.join(',');
    return `https://www.boutiquemate.com/cdn-cgi/image/${paramsString}/${normalizeSrc(src)}`;
};


export function Hero(props) {
    const {
        eventName,
        eventBGImage,
        eventPosterImage,
        providerName,
        providerAddress,
        eventCategories,
        eventSubtitle,
    } = props
    const {colorMode} = useColorMode()
    const bgColor = {light: '#F8F8F8', dark: '#282A29'}
    const color = {light: 'black', dark: 'white'}

    const heroBG = `linear-gradient(to bottom, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.6)), url("${eventBGImage}")`

    const isAAPIEvent = eventName === 'Grand Central Market Presents: AAPI Heritage Month'

    const formattedAddress = providerAddress.split('\n')

    const uniqueStartTimes = [...new Set(eventCategories.flatMap(({category_items}) => category_items.map(({event_start}) => formatStartDateOnlyWithoutTimezone(event_start))))]

    return (
        <Box
            bgImage={heroBG}
            bgPosition='center'
            bgSize='cover'
            pt='4.5rem'
        >
            <Flex
                maxW='1024px'
                mx='auto'
                as="section"
                direction="column"
                align="center"
            >
                <Center>
                    <Image src={providerLogo} height={74} width={300} alt="Grand Central Market Logo"/>
                </Center>
                <Stack direction={{base: 'column', md: 'row'}} pt={{base: '8', md: '16'}} pb={{base: '0', md: '12'}}>
                    {/* TODO: Figure out how this sizing should work */}
                    {eventPosterImage &&
                        <Box p={4}>
                            {/* TODO: Use API */}
                            <Box width={{base:'100%', md:'500px'}} height={{base:'500px', md:'100%'}} position='relative'>
                                <Image
                                    loader={cloudflareLoader}
                                    // width={600}
                                    // height={800}
                                    layout="fill"
                                    objectFit='contain'
                                    src={eventPosterImage}
                                    alt='Event Poster'
                                />
                            </Box>
                        </Box>
                    }
                    {/* <Box p={{base: '8', sm: '4'}}> */}
                    {/*    /!* TODO: Use API *!/ */}
                    {/*    <Image src={isAAPIEvent ? AAPIEventPoster : BingoEventPoster} alt='Bingo Event'/> */}
                    {/* </Box> */}
                    <Flex p={8} direction="column">
                        <Heading
                            size="xl"
                            fontFamily="heading"
                            letterSpacing="tight"
                            fontWeight="bold"
                            color="white"
                            mb="4"
                            lineHeight="1.2"
                        >
                            {eventName}
                        </Heading>

                        <Stack direction='column' align="baseline">
                            {/* <Stack direction="row" spacing={2}>
                                {
                                    eventCategories.map((name) => (
                                        <Tag
                                            size="sm"
                                            key={name.category_name}
                                            borderRadius="full"
                                            variant="solid"
                                            // colorScheme="green"
                                            bg="#91099D"
                                        >
                                            <TagLabel>{name.category_name}</TagLabel>
                                        </Tag>
                                    ))
                                }
                            </Stack> */}
                            
                            <Tag
                                size="lg"
                                borderRadius="full"
                                variant="solid"
                                // colorScheme="green"
                                bg="#91099D"
                            >
                                <TagLabel>Lower Level</TagLabel>
                            </Tag>
                            {eventSubtitle &&
                                <Text
                                    whiteSpace='pre-line'
                                    opacity={0.85}
                                    fontSize={{base: 'xl', lg: '2xl'}}
                                    pr="2"
                                    maxW='500px'
                                    color="white"
                                >
                                    {eventSubtitle}
                                </Text>
                            }
                            <Stack direction={{base: 'column', md: 'column'}} pt={4} pb={4} spacing={4}>
                                <Stack direction='column' width={{sm: '100%', md: '50%'}}>
                                    {uniqueStartTimes.map((startTime) => (
                                        <Flex key={startTime} direction='row' align='center'>
                                            <Box p={2}>
                                                <CalendarIcon size="20px" color='white'/>
                                            </Box>
                                            <Text key={startTime} fontSize={{base: 'lg', lg: 'xl'}} fontWeight='bold'
                                                  color='white'
                                                  whiteSpace='pre-line'>
                                                {startTime}
                                            </Text>
                                        </Flex>
                                    ))}
                                </Stack>
                                <Stack direction='row'>
                                    <Box p={2} pr={0}>
                                        <LocationIcon size="20px" color='white'/>
                                    </Box>
                                    <Text
                                        fontSize={{base: 'lg', lg: 'xl'}}
                                        color='white'
                                    >
                                        <>
                                            <b>{providerName}</b> <br/>
                                            {formattedAddress[0]} <br/>
                                            {formattedAddress[1]}
                                        </>
                                    </Text>
                                </Stack>
                            </Stack>
                        </Stack>
                    </Flex>
                </Stack>
            </Flex>
        </Box>
    )
}
